<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSearch" :autoFormCreate="(form) => {
        this.searchForm = form;
      }
        ">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="供应商" fieldDecoratorId="supplier_id">
              <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in suppliers" :key="item.id">{{
                  item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="门店" fieldDecoratorId="branch_id">
              <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in branches" :key="item.id">{{
                  item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="订单状态" fieldDecoratorId="state">
              <a-select placeholder="请选择" allowClear>
                <a-select-option :value="0">待处理</a-select-option>
                <a-select-option :value="1">在途</a-select-option>
                <a-select-option :value="2">到店上架中</a-select-option>
                <a-select-option :value="3">到货正常</a-select-option>
                <a-select-option :value="4">到货异常</a-select-option>
                <a-select-option :value="5">处理完成</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="操作人" fieldDecoratorId="admin_user_id">
              <a-select placeholder="请选择">
                <a-select-option v-for="item in operators" :key="item.id">{{
                  item.real_name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="订单编号" fieldDecoratorId="order_no">
              <a-input placeholder="采购订单编号" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="订单日期" fieldDecoratorId="date_range">
              <a-range-picker />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-button type="primary" htmlType="submit">查询</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table ref="table" size="default" :columns="columns" :data="loadData">
      <template slot="logistics_no" slot-scope="text">
        <span :href="text" target="_blank" v-if="text">{{text}}</span>
        <span v-else>--</span>
      </template>
      <template slot="type" slot-scope="text">
        {{ text | purchaseTypeStr }}
      </template>
      <template slot="state" slot-scope="text">
        {{ text | SorderStateFilter }}
      </template>
      <template slot="branch_name" slot-scope="text, record">
        <span v-if="record.type == 0 || record.type == 1">{{ text }}</span>
        <span v-else>{{ text + "," + record.purchase_order_move_record.map(item => item.branch_name).join(",") }}</span>
      </template>
      <template slot="action" slot-scope="text, record">
        <div class="editable-row-operations">
          <a @click="handleView(record)">查看订单</a>
          <a-divider type="vertical" />
          <!-- <a-popconfirm
            v-if="record.state == 0"
            title="确认发货吗？"
            @confirm="handleDelivery(record)"
          >
            <a>发货</a>
          </a-popconfirm> -->
          <a v-if="record.state == 0" @click="showSendModal(record)">发货</a>
          <a-divider type="vertical" />
          <a @click="handleExport(record)">导出</a>
          <a-divider type="vertical" />
          <a @click="handlegoLog(record)">操作日志</a>
          <a-divider type="vertical" v-if="record.state == 0" />
          <a-popconfirm v-if="record.state == 0" title="确认删除吗？" @confirm="handleDelete(record)">
            <a>删除</a>
          </a-popconfirm>
          <a-divider v-if="canRemark" type="vertical" />
          <a v-if="canRemark" @click="handleRemark(record)">查看备注</a>
        </div>
      </template>
    </s-table>
    <a-modal title="确认发货" :width="600" v-model="send.visible" okText="确认发货" @ok="handleDelivery(send)"
      @cancel="send.visible = false">
      <a-row style="line-height:32px;">
        <a-col :span="4">
          订单编号：
        </a-col>
        <a-col :span="20">
          {{ send.orderNo }}
        </a-col>
        <a-col :span="24" style="height:16px"></a-col>
        <a-col :span="4">
          订单类型：
        </a-col>
        <a-col :span="20">
          {{ send.orderType }}
        </a-col>
        <a-col :span="24" style="height:16px"></a-col>
        <a-col :span="4">
          归属门店：
        </a-col>
        <a-col :span="20">
          {{ send.branchName }}
        </a-col>
        <a-col :span="24" style="height:16px"></a-col>
        <a-col :span="4">
          订单件数：
        </a-col>
        <a-col :span="20">
          <a-input-number :min="1" v-model="send.packageQuantity" style="width:20%" />
        </a-col>
        <a-col :span="24" style="height:16px"></a-col>
        <a-col :span="4">
          物流单号：
        </a-col>
        <a-col :span="20">
          <a-input :min="1" v-model="send.logistics_no" style="width:60%" />
        </a-col>
        <!-- <a-col :span="24">
          <a-upload
          name="file"
          listType="picture-card"
          class="avatar-uploader"
          :showUploadList="false"
          action="//upload.qiniup.com"
          :beforeUpload="beforeCoverUpload"
          :data="imgForm"
          @change="handleCoverChange"
        >
          <img width="128" height="128" v-if="send.orderPicUrl" :src="send.orderPicUrl" />
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        </a-col> -->
      </a-row>

    </a-modal>
    <a-modal title="物流情况" :width="600" v-model="visible" okText="提交" @ok="handleOk" @cancel="visible = false">
      <a-form :autoFormCreate="(form) => {
        this.form = form;
      }
        ">
        <a-form-item label="物流公司">
          <a-input v-model="temp.company" placeholder="请输入物流公司" />
        </a-form-item>
        <a-form-item label="物流单" fieldDecoratorId="courier" :fieldDecoratorOptions="{
          rules: [{ required: false, message: '请上传物流单' }],
          initialValue: temp.courier,
        }">
          <a-upload name="file" listType="picture-card" class="avatar-uploader" :showUploadList="false"
            action="//upload.qiniup.com" :beforeUpload="beforeCoverUpload" :data="imgForm" @change="handleCoverChange">
            <img width="200" height="128" v-if="courier" :src="courier" />
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item label="物流费">
          <a-input v-model="temp.money" placeholder="请输入物流费" />
        </a-form-item>
        <a-form-item label="差价">
          <a-input v-model="temp.bill" placeholder="请输入差价" />
        </a-form-item>
        <a-form-item label="差价原因">
          <a-input v-model="temp.note" placeholder="请输入差价原因" />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal title="备注" :visible="remarkVisible" @ok="_handleOk" @cancel="handleCancel" :maskClosable="false">
      <s-table ref="remark" :columns="remarkColums" :data="loadRemarkData" :pageSize="5">
        <template slot="remarkType" slot-scope="text">
          {{ text === 1 ? "门店留言" : "采购留言" }}
        </template>
      </s-table>
      <a-textarea :rows="3" v-model.number="currentRecord.remark" placeholder="请填写处理备注" />
      <div class="tips">
        <p>
          请根据与厂商沟通后订单异常原因告知门店处理结果以及后续如何处理该笔订单
        </p>
        <p>异常情况提示以及处理方式：</p>
        <p>情况1：厂商分批发货-处理方式：备注告知门店,等待到货后正常收货</p>
        <p>
          情况2：厂商货品数量有误 -处理方式：点击退款
          备注告知门店让门店点击处理完毕(仅限于实际到货低于采购量，如实际到货数量高于采购量则根据实际到货量生成新订单)
        </p>
        <p>
          情况3: 厂商货品种类有误-处理方式： 点击退款
          生成实际到货商品的新订单，并将新生成订单的订单编号备注,让门店对新订单收货/对旧订单点击处理完毕
        </p>
      </div>
    </a-modal>
  </a-card>
</template>
<script>
import STable from "@/components/table/";
import { getBranchList } from "@/api/branch";
import { getSupplierList } from "@/api/supplier";
import { getStaffList } from "@/api/staff";
import {
  getSorderList,
  updateLogistics,
  sendOut,
  delPurchase,
  remarkPurchase,
} from "@/api/purchase";
import { getRemarkList } from "@/api/stock";
import { getQiniuToken } from "@/api/qiniu";
import { encodeJsonToQuery } from "@/utils/util";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import Vue from 'vue'

export default {
  name: "BuyList",
  components: {
    STable,
  },
  data() {
    return {
      send: {
        visible: false,
        state: null,
        orderID: "",
        orderNo: "",
        orderType: "",
        branchName: "",
        orderPicUrl: "",
        packageQuantity: "",
        logistics_no: "",
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: null,
      // 查询参数
      visible: false,
      loading: false,
      downloadLoading: false,
      searchForm: null,
      courier: "",
      advanced: false,
      imgForm: {},
      queryParam: {},
      // 表头
      temp: {},
      branches: [],
      suppliers: [],
      operators: [],
      remarkVisible: false,
      canRemark: false,
      currentRecord: {},
      columns: [
        {
          title: "订单号码",
          dataIndex: "logistics_no",
          scopedSlots: { customRender: "logistics_no" },
        },
        {
          title: "采购订单编号",
          dataIndex: "order_no",
        },
        {
          title: "采购操作人",
          dataIndex: "admin_user_name",
        },
        {
          title: "门店",
          dataIndex: "branch_name",
          scopedSlots: { customRender: "branch_name" }
        },
        {
          title: "供应商",
          dataIndex: "supplier_name",
        },
        {
          title: "订单类型",
          dataIndex: "type",
          scopedSlots: { customRender: "type" },
        },
        // {
        //   title: "供应商",
        //   dataIndex: "supplier_name",
        // },
        {
          title: "下单时间",
          dataIndex: "created",
        },
        {
          title: "订单状态",
          dataIndex: "state",
          scopedSlots: { customRender: "state" },
        },
        // {
        //   title: "备注",
        //   dataIndex: "remark",
        // },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      remarkColums: [
        {
          title: "备注类型",
          dataIndex: "type",
          scopedSlots: { customRender: "remarkType" },
        },
        {
          title: "备注内容",
          dataIndex: "content",
        },
      ],
      loadData: (params) => {
        return getSorderList(Object.assign(params, this.queryParam)).then(
          (res) => res
        );
      },
      loadRemarkData: (params) => {
        if (this.currentRecord && this.currentRecord.id) {
          const page = params.page || 1;
          const page_size = params.page_size || 5;
          return getRemarkList({ page, page_size }, this.currentRecord.id).then(
            (res) => res
          );
        }
        return Promise.resolve([]);
      },
    };
  },
  created() {
    this.getBranchList();
    this.getSupplierList();
    this.getOperators();
    let userInfo = this.$ls.get("userInfo") || {};
    if (userInfo.role === "admin" || userInfo.role === "merchandiser") {
      this.canRemark = true;
    }
  },
  methods: {
    showSendModal: function (record) {
      console.log(record)
      this.send = {
        visible: true,
        state: record.state,
        orderID: record.id,
        orderNo: record.order_no,
        orderType: Vue.filter("purchaseTypeStr")(record.type),
        branchName: record.branch_name,
        orderPicUrl: "",
        packageQuantity: "",
        logistics_no: ""
      }
    },
    getBranchList: function () {
      getBranchList().then((res) => {
        this.branches = res.list;
      });
    },
    getSupplierList: function () {
      getSupplierList().then((res) => {
        this.suppliers = res.list;
      });
    },
    getOperators: function () {
      getStaffList().then((res) => {
        this.operators = res.list;
      });
    },
    handleRemark(row) {
      this.currentRecord = { ...row };
      this.remarkVisible = true;
      this.$refs.remark.refresh();
    },
    handleCancel() {
      this.currentRecord = {};
      this.remarkVisible = false;
    },
    _handleOk() {
      if (!this.currentRecord.remark) {
        this.$message.error("请填写备注");
        return;
      }
      const params = {
        id: this.currentRecord.id,
        remark: this.currentRecord.remark,
      };
      remarkPurchase(params).then((res) => {
        this.$message.success("操作成功");
        // this.$refs.table.refresh();
        this.handleCancel();
      });
    },
    handleDelete: function (record) {
      delPurchase({ id: record.id }).then(() => {
        this.$message.success("操作成功");
        this.$refs.table.refresh();
      });
    },
    handleSearch(e) {
      e.preventDefault();
      let filter = {
        supplier_id: this.searchForm.getFieldValue("supplier_id"),
        branch_id: this.searchForm.getFieldValue("branch_id"),
        admin_user_id: this.searchForm.getFieldValue("admin_user_id"),
        state: this.searchForm.getFieldValue("state"),
        order_no: this.searchForm.getFieldValue("order_no"),
      };
      const date_range = this.searchForm.getFieldValue("date_range");
      if (date_range) {
        filter["start_date"] = date_range[0].format("YYYY-MM-DD");
        filter["end_date"] = date_range[1].format("YYYY-MM-DD");
      }
      this.queryParam = { ...filter };
      this.$refs.table.refresh();
    },
    handleReset() {
      this.searchForm.resetFields();
      this.queryParam = {};
      this.$refs.table.refresh();
    },
    disabledStartDate(startValue) {
      const endValue = this.endValue;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
    handleView(row) {
      let routertwo = this.$router.resolve({
        name: "BuyDetail",
        params: { id: row.id },
      });
      window.open(routertwo.href, "_blank");
    },
    handlegoLog(row) {
      let routertwo = this.$router.resolve({
        name: "purchaseLog",
        params: { id: row.id },
      });
      window.open(routertwo.href, "_blank");
    },
    beforeCoverUpload: function () {
      let _this = this;
      return getQiniuToken().then((res) => {
        _this.bucketHost = res.bucket_host;
        _this.imgForm = {
          // key: res.key,
          token: res.qiniu_token,
        };
      });
    },
    handleCoverChange(info) {
      if (info.file.status === "uploading") {
        this.loading = true;
      } else if (info.file.status === "done") {
        let key = info.file.response.key;
        this.send.orderPicUrl = `${this.bucketHost}${key}`;
        this.loading = false;
      } else if (info.file.status === "error") {
        this.loading = false;
        this.$message.error("上传图片失败，请重试");
      } else if (info.file.status === "removed") {
        console.log("removed");
      }
    },
    handleUpload(row) {
      this.visible = true;
      this.temp = row;
      this.courier = row.courier;
    },
    handleOk() {
      this.form.validateFields((err) => {
        if (!err) {
          const params = {
            company: this.temp.company,
            courier: this.courier,
            money: this.temp.money,
            bill: this.temp.bill,
            note: this.temp.note,
          };
          updateLogistics(this.temp.id, params).then((res) => {
            if (res.code === 0) {
              this.$message.success("操作成功");
              this.visible = false;
              this.temp = {};
              this.$refs.table.refresh();
            }
          });
        }
      });
    },
    handleDelivery(row) {
      if (row.state == 0 && row.packageQuantity && row.logistics_no) {
        const params = {
          id: row.orderID,
        };
        const body = {
          package_quantity: row.packageQuantity,
          logistics_no: row.logistics_no
        }
        this.send.visible = false
        sendOut(params, body).then(() => {
          this.$message.success("操作成功");
          this.$refs.table.refresh();
        });
      } else if (!row.packageQuantity) {
        this.$message.error("请填写订单件数");
        // }else if(!row.orderPicUrl){
        //   this.$message.error("请上传物流单照片");
        // }
      } else if (!row.logistics_no) {
        this.$message.error("请填写物流单号")
      }
    },
    handleExport(row) {
      const params = {
        token: this.$ls.get(ACCESS_TOKEN),
      };
      window.open(
        `/api/admin/purchase/${row.id}/excel${encodeJsonToQuery(params)}`
      );
    },
  },
};
</script>
<style scoped>
.tips {
  font-weight: bold;
  margin-top: 20px;
}
</style>
